import React from 'react';
import { Outlet } from 'react-router-dom';
import EnvBanner from './legacy-components/EnvBanner';
import Navbar from './legacy-components/Navbar';
import MaintenanceBanner from './legacy-components/MaintenanceBanner';
import Footer from './legacy-components/Footer';
import VersionChecker from './legacy-components/VersionChecker';
import { useSecurity, isLimitedTraderOrWlpRole } from './legacy-components/Security/security';

const Layout = () => {
  const { securityState } = useSecurity();
  const limitedAccess = securityState.loggedIn && isLimitedTraderOrWlpRole(securityState);

  return (
    <div className="d-flex flex-column min-vh-100">
      <EnvBanner />
      <Navbar />
      <MaintenanceBanner isLimitedAccess={limitedAccess} />
      <VersionChecker />
      <Outlet />
      <div className="flex-grow-1" />
      <Footer />
    </div>
  );
};
export default Layout;
